import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, inject } from '@angular/core';
import { NgIf, NgFor, NgClass } from '@angular/common';
import { SwapApiService } from '../services/swap-api.service';
import { catchError, of } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { KeyValuePipe } from '@angular/common';

@Component({
  selector: 'app-swap-market-viewer',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, TranslateModule, KeyValuePipe],
  templateUrl: './swap-market-viewer.component.html'
})
export class SwapMarketViewerComponent implements OnInit, OnChanges {
  @Input() tokenIn: string | null = null;
  @Input() tokenOut: string | null = null;
  @Input() chainId: number = 1;
  @Input() amountIn: number | null = null;
  @Input() amountOut: number | null = null;
  @Input() isLoading: boolean = false;
  @Input() hasData: boolean = true;
  @Input() marketTrendData: {
    amount: number;
    trends: { '1h': number; '6h': number; '24h': number };
  } | null = null;
  @Output() trendClicked = new EventEmitter<number>();

  interpolatedTrend: { amount: number; trends: { '1h': number; '6h': number; '24h': number } } | null = null;

  isDarkMode(): boolean {
    return document.body.classList.contains('dark-mode');
  }

  get trendEntries() {
    return this.interpolatedTrend?.trends
      ? Object.entries(this.interpolatedTrend.trends).map(([key, value]) => ({ key, value }))
      : [];
  }



  constructor(private api: SwapApiService) {}

  ngOnInit(): void {
    console.log('[SwapMarketViewer] ▶️ Init avec :', {
      tokenIn: this.tokenIn,
      tokenOut: this.tokenOut,
      amountIn: this.amountIn,
      amountOut: this.amountOut,
      chainId: this.chainId
    });

   
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['marketTrendData'] && this.marketTrendData) {
      this.interpolatedTrend = this.marketTrendData;
    }
  }



  private getMockTrends(): any[] {
    return [
      { timeframe: '1h', pctFromNow: 10 },
      { timeframe: '6h', pctFromNow: 15 },
      { timeframe: '24h', pctFromNow: -7 }
    ];
  }


  handleTrendClick(value: number | undefined): void {
    if (typeof value === 'number' && value > 0) {
      this.onTrendClicked(value);
    }
  }

  onTrendClicked(pct: number): void {
    this.trendClicked.emit(pct);
  }
}
